import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "booking-sidebar" }
const _hoisted_2 = { class: "grid grid-header-title w-full mx-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "my-0 mr-2 ml-0 font-bold" }, "予約詳細")
], -1)
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "m-0" }

import { IBooking } from "@/clinic/typings";
import { withDefaults } from "vue";

// Define your type
type IBookingComponentProps = {
  booking?: IBooking; // Use "?" to indicate it's optional
};

// Use withDefaults to set default values

export default /*#__PURE__*/_defineComponent({
  __name: 'header',
  props: {
    booking: { default: {} }
  },
  setup(__props: any) {

const props = __props as { booking: IBooking };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, "予約番号：" + _toDisplayString(__props.booking?.id), 1)
      ])
    ])
  ]))
}
}

})